define('app',['require','exports','module','lodash','jquery','backbone','layoutmanager','i18n','router','bootstrapValidator','env','helpers/browserDetection','helpers/raven','tagmanager','ThemesHelper','helpers/i18nHelper','helpers/MaintenanceHelper'],function (require, exports, module) {
  "use strict";

  var _ = require('lodash'),
      $ = require('jquery'),
      Backbone = require('backbone'),
      Layout = require('layoutmanager'),
      i18n = require('i18n'),
      Router = require('router'),
      bootstrapValidator = require('bootstrapValidator'),
      Config = require('env'),
      browserDetection = require('helpers/browserDetection'),
      RavenHelper = require('helpers/raven'),
      tagManager = require('tagmanager'),
      ThemesHelper = require('ThemesHelper'),
      i18nHelper = require('helpers/i18nHelper'),
      MaintenanceHelper = require('helpers/MaintenanceHelper');

  var app = module.exports;

  app.root = "/";

  //init sentry:
  RavenHelper.init();

  $.tagManager({id: Config.ga.tagmanagerId});

  // enable CORS
  // http://naleid.com/blog/2012/10/29/overriding-backbone-js-sync-to-allow-cross-origin-resource-sharing-cors
  (function () {
    var proxiedSync = Backbone.sync;

    Backbone.sync = function (method, model, options) {
      options = options || {};

      if (!options.crossDomain) {
        options.crossDomain = true;
      }

      if (!options.xhrFields) {
        options.xhrFields = {
          withCredentials: true
        };
      }

      return proxiedSync(method, model, options);
    };
  })();

  $.ajaxSetup({
    statusCode: {
      401: function () {
        // Redirect the to the login page.
        window.location = Config.backendUrl +
            "/auth?pathname=" + document.location.pathname;
      },
      403: function () {
        // 403 -- Access denied
        window.location = Config.backendUrl +
            "/auth?pathname=" + document.location.pathname;
      }
    }
  });

  $(document).ajaxError(function (event, xhr, settings, thrownError) {
    var msg = "Error handleAjaxError";
    RavenHelper.captureMessage(msg, {
      url: settings.url,
      type: settings.type,
      dataType: settings.dataType,
      jsonp: settings.jsonp,
      jsonpCallback: settings.jsonpCallback,
      thrownError: thrownError
    });
  });

  app.i18n = function (el) {
    var $el = $(el);
    if ($el.i18n) {
      $el.i18n();
    } else {
      i18nHelper.init(function () {
        $el.i18n();
      });
    }
  };

  app.initTheme = function () {
    ThemesHelper.setConfig(Config);
    ThemesHelper.initUserTheme();
  };

  function digestMessage(message) {
    var encoder = new TextEncoder();
    var data = encoder.encode(message);
    return crypto.subtle.digest('SHA-256', data);
  }

  app.start = function () {
    // Maintenance
    MaintenanceHelper.init(function () {
      digestMessage(ThemesHelper.getCookie(MaintenanceHelper.getCookieName()))
        .then(function (digestBuffer) {
          var decoded = btoa(String.fromCharCode.apply(null, new Uint8Array(digestBuffer)));
          if (MaintenanceHelper.isEnabled() && decoded !== MaintenanceHelper.getCookieHash()) {
            window.location.replace(MaintenanceHelper.getRedirectUrl());
          } else {
            app.initTheme();
            i18nHelper.init(app.run);
          }
        });
    });
  };

  app.run = function () {
    browserDetection();
    app.router = new Router();
    Backbone.history.start({
      pushState: true,
      root: app.root
    });

    // Sidebar links behavior:
    $(document).on("click", "#md__sidebar__wrapper a[href]", function (evt) {
      evt.preventDefault();
      evt.stopPropagation();

      var hrefRaw = $(this).prop("href"),
          href = new URL(hrefRaw),
          root = location.protocol + "//" + location.host + app.root,
          targetRoot = href.origin + app.root;

      if (targetRoot === root) {
        // Pathname?  We're in the same domain, so we can just use the segment to navigate.
        if (href.pathname && href.pathname !== app.root) {
          // Forcing the item list to be selected in sidebar bypassing the router.
          var sidebarParentBlockItem = $(evt.currentTarget).closest('li');
          sidebarParentBlockItem.addClass('active').siblings().removeClass('active');

          Backbone.history.navigate(href.pathname, true);
          return;
        }

        // Query string?  Go to actions.
        if (href.search) {
          var urlParams = new URLSearchParams(href.search);
          app.processQueryParams(urlParams);
        }
      } else {
        // Different domain; we force the browser jump:
        window.location.replace(hrefRaw);
      }
    });

    // All navigation that is relative should be passed through the navigate
    // method, to be processed by the router. If the link has a `data-bypass`
    // attribute, bypass the delegation completely.
    $(document).on("click", ".main__section__wrapper a[href]:not([data-bypass])", function (evt) {
      // Get the absolute anchor href.
      var href = {
        prop: $(this).prop("href"),
        attr: $(this).attr("href")
      };
      // Get the absolute root.
      var root = location.protocol + "//" + location.host + app.root;

      // Ensure the root is part of the anchor href, meaning it's relative.
      if (href.prop.slice(0, root.length) === root) {
        // Stop the default event to ensure the link will not cause a page
        // refresh.
        evt.preventDefault();

        // `Backbone.history.navigate` is sufficient for all Routers and will
        // trigger the correct events. The Router's internal `navigate` method
        // calls this anyways.  The fragment is sliced from the root.
        Backbone.history.navigate(href.attr, true);
      }
    });
  };
});

